"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueEntityCellItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _IssuesConsumer = require("../IssuesConsumer");
var _statusFieldHelpers = require("../utils/data/statusFieldHelpers");
var _accReferencePicker = require("@adsk/acc-reference-picker");
var _alloyProvider = require("@adsk/alloy-provider");
var _alloyReactStatusColorIndicator = _interopRequireDefault(require("@adsk/alloy-react-status-color-indicator"));
var _alloyReactTheme = _interopRequireDefault(require("@adsk/alloy-react-theme"));
var _utils = require("./helpers/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const IssueEntityCellItem = exports.IssueEntityCellItem = (0, _IssuesConsumer.withIssuesConsumer)(_ref => {
  let {
    entity,
    ...rest
  } = _ref;
  const projectId = (0, _alloyProvider.useCurrentProjectId)();
  const {
    displayId,
    id: issueId,
    status,
    title
  } = entity;
  const url = (0, _utils.getIssueUrl)({
    projectId,
    issueId
  });
  const label = /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "inline-flex",
      alignItems: "center"
    }
  }, status && /*#__PURE__*/_react.default.createElement(_alloyReactStatusColorIndicator.default, {
    style: {
      width: 3,
      height: 16,
      cursor: "default",
      backgroundColor: (0, _statusFieldHelpers.getStatusColor)(status)
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      paddingLeft: 3
    }
  }, "#".concat(displayId)), /*#__PURE__*/_react.default.createElement("span", {
    style: {
      paddingLeft: 3,
      color: _alloyReactTheme.default.colors.charcoal700
    }
  }, title));
  return /*#__PURE__*/_react.default.createElement(_accReferencePicker.EntityMenuItem, _extends({
    key: entity.id,
    link: url,
    label: label
  }, rest));
});
//# sourceMappingURL=IssueEntityCellItem.js.map